import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { ProductRatingViewController } from '../controllers/ProductRatingViewController';

export class RatingSelectedUseCase {
    private selectedIndex: number;
    private productRatingViewController: ProductRatingViewController;

    constructor(selectedIndex: number) {
        this.selectedIndex = selectedIndex;
        this.productRatingViewController = diContainer.get(
            serviceNames.productRatingViewController
        );
    }

    public execute = () => {
        this.productRatingViewController.setRating(this.selectedIndex);
    };
}
